/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { qreq } from "../shared/qrequest";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Icon from "./Icon";

export default class AccountSelect extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        };
        this.isSelected = this.isSelected.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        qreq.get('/api/account/list', j => {
            if (j.list)
                this.setState({ list: j.list });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    isSelected(account) {
        if(this.props.mainAccountID === account.id)
            return true;
        if(this.props.selectedAccounts?.find(a => a.id === account.id))
            return true;
        return false;
    }

    toggle(account) {
        var selectedAccounts = [...this.props.selectedAccounts];
        if(!selectedAccounts)
            return;
        if(this.props.mainAccountID === account.id)
            return;
        var idx = selectedAccounts.findIndex(a => a.id === account.id);
        if(idx >= 0)
            selectedAccounts.splice(idx, 1);
        else
            selectedAccounts.push(account);
        this.props.onChange?.(selectedAccounts);
    }
    
    render() {
        return <div className="list-group">
            {this.state.list?.map(i => <div key={i.id} role="button" onClick={() => this.toggle(i)} className={'list-group-item' + (i.id === this.props.mainAccountID ? ' bg-success text-white' : this.isSelected(i) ? ' active' : '')}><Icon icon={i.id === this.props.mainAccountID ? 'faLock' : this.isSelected(i) ? 'faCircleCheck' : 'faCircle'} className={this.isSelected(i) ? 'text-white' : 'text-dark'} /> {i.name}</div>)}
        </div>;
    }
}